import { useTranslation } from 'react-i18next'

type Props = {
  totalCount: number
}

const HumanReviewHeader = ({ totalCount }: Props) => {
  const { t } = useTranslation()

  return (
    <div>
      <h1 className="c-text-lg c-font-semibold">
        {t('pages.dashboard.human-review-requests.title', { count: totalCount })}
      </h1>
      <p className="c-text-sm c-text-grey-600 c-mb-0">
        {t('pages.dashboard.human-review-requests.subtitle')}
      </p>
    </div>
  )
}

export default HumanReviewHeader
